import React from 'react'
import { FormattedMessage } from 'react-intl'
import { string, shape, func } from 'prop-types'
import Checkbox from '@components/Checkbox'

export default function DynamicCheckbox({ field, register, errors }) {
  const { formatLabel } = field

  let formats = {}

  if (formatLabel) {
    if (formatLabel.type === 'link') {
      formats = {
        a: (...chunks) => (
          <a
            href={formatLabel.value}
            target={`_${formatLabel.target}`}
            rel="noopener noreferrer"
          >
            {chunks}
          </a>
        ),
      }
    }
  }

  return (
    <div data-testid="dynamic-form-checkbox">
      <Checkbox
        name={field.name}
        reference={register}
        onChange={field.actions && field.actions.onChange}
        errorMessage={errors && errors.message}
        label={
          field.formatLabel ? (
            <label data-testid="dynamic-form-checkbox-format-label">
              <FormattedMessage id={field.originalLabel} values={formats} />
            </label>
          ) : (
            <label dangerouslySetInnerHTML={{ __html: field.label }} />
          )
        }
      />
    </div>
  )
}

DynamicCheckbox.propTypes = {
  field: shape({
    label: string,
    name: string,
  }).isRequired,
  register: func.isRequired,
  errors: shape({}),
}

DynamicCheckbox.defaultProps = {
  errors: {},
}
